const t = ["section", "heading", "link"];
var n = /* @__PURE__ */ ((i) => (i.Section = "section", i.Heading = "heading", i.Link = "link", i))(n || {});
export {
  t as EXPANDER_MODES,
  n as ExpanderMode
};
